import * as React from "react";
const SvgFiRrRv = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-rv_svg__a)">
      <path
        fill="#062147"
        d="M20.723 7H22a2 2 0 0 0 2-2 4 4 0 0 0-4-4H5a5.006 5.006 0 0 0-5 5v6.515a6.95 6.95 0 0 0 2.05 4.949l.95.95V19.5a3.5 3.5 0 1 0 7 0V19h5v.5a3.5 3.5 0 0 0 7 0V19h1a1 1 0 0 0 1-1v-3.407a7 7 0 0 0-.922-3.472zM2 7h6v2H2zm6 12.5a1.5 1.5 0 0 1-3 0V19h3zm5-2.5H4.414l-.95-.95A4.97 4.97 0 0 1 2 12.515V11h6a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H2.172A3 3 0 0 1 5 3h15a2 2 0 0 1 2 2h-5a4 4 0 0 0-4 4zm7.7-6H15V9a2 2 0 0 1 2-2h1.419zm-.7 8.5a1.5 1.5 0 1 1-3 0V19h3zm2-2.5h-7v-4h6.739A5 5 0 0 1 22 14.593z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-rv_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRv;
